import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { InlineLoading, Tooltip, ProgressIndicator, ProgressStep, Button, Tile, TextInput, Select, SelectItem, SelectItemGroup } from 'carbon-components-react'
import AuthContext from '../../context/AuthContext'
import 'react-quill/dist/quill.bubble.css'
import SignatureCanvas from 'react-signature-canvas'
import { sleep } from '../../utils/functions/tools/sleep';
import parse from 'html-react-parser';
import flptslogot from '../../static/flptslogot.png';
import { normalizePhone, deNormalizePhone } from '../../utils/functions/tools/normalizePhone';

const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const SignatureShell = ({ match }) => {

    const [display, setDisplay] = useState(1);
    const [progressIndex, setProgressIndex] = useState(0);

    const [list, setList] = useState([]);
    const [editorContent, setEditorContent] = useState('')
    let toastProperties = null;

    //assigning location variable
    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");

    // Inline loading for Submission
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [description, setDescription] = useState('Sending...');
    const [ariaLive, setAriaLive] = useState('off');
    const [inlineLoadingState, setInlineLoadingState] = useState('');

    // Variables for modals and toasts
    const [error, setError] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [editContactID, setEditContactID] = useState(false);
    const [openEditAgreementModal, setOpenEditAgreementModal] = useState(false);
    const signatureCanvas = useRef();

    // Variables for noteSeaarch
    let [client, setClients] = useState(null)

    // Other Variables
    let [clientIP, setClientIP] = useState("")
    let [pdf, setPDF] = useState(null)
    let [counties, setCounties] = useState([])
    let [provinces, setProvinces] = useState([])
    let profileId = match.params.id
    let [tabActive, setTabActive] = useState(true)
    let [page, setPage] = useState(null)
    let [status, setStatus] = useState('')
    let [contacts, setContacts] = useState([])
    let [clientAddress, setClientAddress] = useState(null)
    let [clientAddresses, setClientAddresses] = useState(null)
    let [clientPhoneNumbers, setClientPhoneNumbers] = useState(null)
    let [clientEmailAddresses, setClientEmailAddresses] = useState(null)
    let [clientMailingAddress, setClientMailingAddress] = useState(null)
    let [clientBillingAddress, setClientBillingAddress] = useState(null)
    let [clientSettings, setClientSettings] = useState(null)
    let [currencies, setCurrencies] = useState(null)
    let [currencyCode, setCurrencyCode] = useState(null)
    let [countries, setCountries] = useState([])
    let [clientCountry, setClientCountry] = useState(null)
    let [savedState, setSavedState] = useState('No Changes Made')
    let [page1Submit, setPage1Submit] = useState(false)
    let [page2Submit, setPage2Submit] = useState(false)
    let [isSigned, setIsSigned] = useState(false)

    useEffect(() => {
        getAgreement()
        getCounties()
        getProvinces()
        getCountries()
        document.title = "FLPTS - Property Tax Review & Appeal Agreement"
        setPage(splitLocation[2])
        getClientIP()
    }, [profileId, editContactID])

    useEffect(() => {
        setPage(splitLocation[2])
    })

    let getClientIP = async () => {
        let response = await fetch(`${API_URL}/tools/ip/`)
        let data = await response.json()
        setClientIP(data)
    }

    let submitPage1 = async () => {
        setPage1Submit(true)
        if (first_name != "" && last_name != "" && email_address != "" & phone_number != "" && mailingStreet1 != "" && mailingCity != "" && mailingPostalcode != "" && mailingState != "") {
            setDisplay(2)
            setProgressIndex(1)
        }
    }

    let submitPage2 = async () => {
        setPage2Submit(true)
        if (propertyStreet1 != "" && propertyCity != "" && propertyPostalcode != "" & propertyState != "" && county != "" && county != "placeholder-item") {
            setDisplay(3)
            setProgressIndex(2)
        }
    }

    let getAgreement = async () => {
        let response = await fetch(`${API_URL}/public-agreements/${profileId}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        let data = await response.json()
        
        setEditorContent(data.content)
        setClients(data)
    }

    const getCounties = async () => {
        let response = await fetch(`${API_URL}/public-agreements/data/counties/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        let data = await response.json()
        setCounties(data)
    }

    const getProvinces = async () => {
        let responseProv = await fetch(`${API_URL}/public-agreements/data/provinces/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        let dataProvinces = await responseProv.json()
        setProvinces(dataProvinces)
    }

    const getCountries = async () => {
        let responseCountry = await fetch(`${API_URL}/public-agreements/data/countries/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        let dataCountries = await responseCountry.json()
        setCountries(dataCountries)
        setMailingCountry('US')
        setPropertyCountry('US')
    }

    const showToast = (type, title, description) => {
        const id = Math.floor((Math.random() * 100) + 1);
        const time = new Date().toLocaleString();

        switch (type) {
            case 'success':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'success',
                    time: time
                }
                break;
            case 'error':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'error',
                    time: time
                }
                break;
            case 'info':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'info',
                    time: time
                }
                break;
            case 'warning':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'warning',
                    time: time
                }
                break;
            default:
                setList([]);
        }
        setList([...list, toastProperties]);
    }

    let submitAgreement = async (values) => {
        values.preventDefault()

        setIsSubmitting(true);
        setAriaLive('assertive');

        let response = fetch(`${API_URL}/submissions/submit/${profileId}/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: "blob",
            body: JSON.stringify({
                //Agreement Info
                'content': client?.content, //Changed from agreement due to PDF generation changes
                'signeddate': signeddate,
                'signature': signatureCanvas.current.toDataURL(),
                'ipaddress': clientIP,

                //Contact Info
                'first_name': first_name,
                'last_name': last_name,
                'entityname': entityname,
                'email_address': email_address,
                'phone_number': deNormalizePhone(phone_number),
                'street': mailingStreet1,
                'street2': mailingStreet2,
                'city': mailingCity,
                'postalcode': mailingPostalcode,
                'state': mailingState,
                'country':mailingCountry,

                //Property Info
                'propertystreet': propertyStreet1,
                'propertystreet2': propertyStreet2,
                'propertycity': propertyCity,
                'propertystate': propertyState,
                'propertycountry':propertyCountry,
                'propertypostalcode': propertyPostalcode,
                'folio': folio,
                'county': county,
            })
        }).then(response => response.blob()).then((file) => {
            const filename = new File([file], "signed-agreement-" + first_name + "_" + last_name + ".pdf");
            const url = URL.createObjectURL(filename);
            setPDF(url)

            showToast("success", "Success", "Agreement has been added. Please wait for redirect.")
            setError(false)
            setIsSubmitting(false);
            setSuccess(true);
            setDescription('Sent!');
            setInlineLoadingState("finished")
            setDisplay(4)
            setProgressIndex(3)

            sleep(2000)
            setSuccess(false);
            setDescription('Sending...');
            setAriaLive('off');
            setInlineLoadingState("")
        }).catch((error) => {
            console.log('There has been a problem with downloading the PDF: ' + error.message);
            setError(true)
            setIsSubmitting(false);
            setSuccess(true);
            setDescription('Something went wrong.');
            setInlineLoadingState("error")

            sleep(2000)
            setSuccess(false);
            setDescription('Sending...');
            setAriaLive('off');
            setInlineLoadingState("")
        });
    }

    let downloadPDF = async () => {
        var fileLink = document.createElement('a');
            fileLink.href = pdf;
            fileLink.target = "_blank";

            // it forces the name of the downloaded file
            fileLink.download = 'signed-agreement-' + first_name + "_" + last_name + '.pdf';

            // triggers the click event
            fileLink.click();
    }

    let handleMailStreet2 = async (e) => {
        setMailingStreet2(e)
        setMailingStreet2Ammended(e)

        if (mailingStreet2 != '') {
            setMailingStreet2Ammended(e + ', ')
        }
    }

    let handlePropStreet2 = async (e) => {
        setPropertyStreet2(e)
        setPropertyStreet2Ammended(e)

        if (propertyStreet2 != '') {
            setPropertyStreet2Ammended(e + ', ')
        }
    }

    let sameAsMailing = async () => {
        setPropertyStreet1(mailingStreet1)
        setPropertyStreet2(mailingStreet2)
        setPropertyCity(mailingCity)
        setPropertyPostalcode(mailingPostalcode)
        setPropertyState(mailingState)
    }

    // Agreement Fields
    const [first_name, setFirst_name] = useState('')
    const [last_name, setLast_name] = useState('')
    const [email_address, setEmail_address] = useState('')
    const [phone_number, setPhone_number] = useState('')
    const [displayOneNull, setDisplayOneNull] = useState(false)
    const currentDay = new Date().toLocaleString("en-US", { day: '2-digit' })
    const currentMonth = new Date().toLocaleString("en-US", { month: "long" })
    const currentYear = new Date().getFullYear()
    const currentFullDateTime = new Date().toLocaleString() + ""
    const signeddate = currentYear + "-" + new Date().toLocaleString("en-US", { month: "2-digit" }) + "-" + currentDay + " " + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds()

    const [entityname, setEntityname] = useState('')
    const [mailingStreet1, setMailingStreet1] = useState('')
    const [mailingStreet2, setMailingStreet2] = useState('')
    const [mailingStreet2Ammended, setMailingStreet2Ammended] = useState('')
    const [mailingCity, setMailingCity] = useState('')
    const [mailingPostalcode, setMailingPostalcode] = useState('')
    const [mailingState, setMailingState] = useState('')
    const [mailingCountry, setMailingCountry] = useState('')

    const [propertyStreet1, setPropertyStreet1] = useState('')
    const [propertyStreet2, setPropertyStreet2] = useState('')
    const [propertyStreet2Ammended, setPropertyStreet2Ammended] = useState('')
    const [propertyCity, setPropertyCity] = useState('')
    const [propertyPostalcode, setPropertyPostalcode] = useState('')
    const [propertyState, setPropertyState] = useState('')
    const [propertyCountry, setPropertyCountry] = useState('')
    const [folio, setFolio] = useState('')
    const [county, setCounty] = useState('placeholder-item')
    const [signature, setSignature] = useState('')

    const headerHtml = `
                <div style="text-align: center;padding-top:20px">
                    <span style="font-size: 12pt;"><strong>Property Tax Review and Appeal Agreement</strong></span>
                </div>

                <table style="width:100%;margin-top: 10px;margin-left:-4x">
                    <tr>
                    <td style="text-align: left; width: 100%;">
                        <div style="display: flex; align-items: baseline;">
                        <strong style="white-space: nowrap;">Client Name:</strong>
                        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid black;">
                            {CONTACT_NAME}&nbsp;&nbsp;
                        </div>
                        </div>
                    </td>
                    </tr>
                </table>

                <table style="width:100%;margin-top:8px;margin-left:-4x">
                    <tr>
                    <td style="text-align: left; width: 100%;">
                        <div style="display: flex; align-items: baseline;">
                        <strong style="white-space: nowrap;">Property Address:</strong>
                        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid black;">
                            {PROPERTY_STREET1}, {PROPERTY_STREET2}{PROPERTY_CITY}, {PROPERTY_STATE},
                        {PROPERTY_POSTALCODE}, {PROPERTY_COUNTRY}&nbsp;&nbsp;
                        </div>
                        </div>
                    </td>
                    </tr>
                </table>

                <table style="width:100%;margin-top:8px;margin-left:-4x">
                    <tr>
                    <td style="text-align: left; width: 10%;">
                        <strong>Folio No.:</strong>
                    </td>
                    <td style="text-align: left; width: 30%; padding-right:10px;">
                        <div style="display: flex; align-items: baseline; border-bottom: 1px solid #000;">
                        <span>{FOLIO}&nbsp;&nbsp;</span>
                        <div style="flex: 1;"></div>
                        </div>
                    </td>
                    <td style="text-align: left; width: 7%;">
                        <strong>County:</strong>
                    </td>
                    <td style="text-align: left; width: 43%;">
                        <div style="display: flex; align-items: baseline; border-bottom: 1px solid #000;">
                        <span>{COUNTY}&nbsp;&nbsp;</span>
                        <div style="flex: 1;"></div>
                        </div>
                    </td>
                    </tr>
                </table>

                <table style="width:100%;margin-top:8px;margin-left:-4x">
                    <tr>
                    <td style="text-align: left; width: 11%;">
                        <strong>Phone No.:</strong>
                    </td>
                    <td style="text-align: left; width: 30%; padding-right:10px;">
                        <div style="display: flex; align-items: baseline; border-bottom: 1px solid #000;">
                        <span>{PHONE_NUMBER}&nbsp;&nbsp;</span>
                        <div style="flex: 1;"></div>
                        </div>
                    </td>
                    <td style="text-align: left; width: 7%;">
                        <strong>E-Mail:</strong>
                    </td>
                    <td style="text-align: left; width: 52%;">
                        <div style="display: flex; align-items: baseline; border-bottom: 1px solid #000;">
                        <span>{EMAIL_ADDRESS}&nbsp;&nbsp;</span>
                        <div style="flex: 1;"></div>
                        </div>
                    </td>
                    </tr>
                </table>

                <table style="width:100%;margin-top:8px;margin-left:-4x">
                    <tr>
                    <td style="text-align: left; width: 100%;">
                        <div style="display: flex; align-items: baseline;">
                        <strong style="white-space: nowrap;">Mailing Address:</strong>
                        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid black;">
                            {MAILING_STREET1}, {MAILING_STREET2}{MAILING_CITY}, {MAILING_STATE},
                        {MAILING_POSTALCODE}, {MAILING_COUNTRY}&nbsp;&nbsp;
                        </div>
                        </div>
                    </td>
                    </tr>
                </table>
                </br>
                `;
        const footerHtml = `<table class="publicSign-table" style="width: 50%;">
    <tbody>
        <tr style="vertical-align: bottom;">
        <td style="text-align: left; padding-right: 6px;">Agreed and accepted this</td>

        <td style="width: 40px;">
            <div style="border-bottom: 1px solid #000; text-align: center;">
            01
            </div>
        </td>

        <td style="text-align: center; padding: 0 8px;">of</td>

        <td style="width: 80px;">
            <div style="border-bottom: 1px solid #000; text-align: center;">
            July
            </div>
        </td>

        <td style="text-align: left; padding-left: 6px;">, 2025.</td>
        </tr>
    </tbody>
    </table>

    <div style="text-align: left;padding-top:40px"><span><strong>{CONTACT_NAME}</strong></span>
    </div>

    <table style="width:100%;margin-top:8px;margin-left:-4x">
        <tr>
            <td style="text-align: left;vertical-align: bottom; width:4%">By:</td>
            <td style="text-align: left;border-bottom: 1px solid #000;width: 39%;">
                <div class="se-component se-image-container __se__float-none" style="width: 39%">
                    
                </div>
            </td>
            <td style="width:18%"></td>
            <td style="text-align: left;border-bottom: 1px solid #000;width: 42%;">
                <div class="se-component se-image-container __se__float-none" style="width: 35%">
                    <figure style="margin: 0px; width: 100%;">
                        <img src="data:image/png;base64,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"
                            alt="" data-rotate="" data-proportion="true" data-size="50%,auto" data-align="none"
                            data-percentage="50%,auto" data-file-name="ahern-sig-transparent.png" data-file-size="7358"
                            data-origin="," origin-size="179,72" style="width: 100%; height: 100%;" data-index="0">
                    </figure>
                </div>
            </td>
        </tr>
    </table>
    <table style="width:100%;margin-top:4px;margin-left:-4x">
        <tr>
            <td style="width:36%;">Signature of Authorized Representative</td>
            <td style="width:24%"></td>
            <td style="width:40%">
                Alfredo Hernandez, Manager
            </td>
        </tr>
    </table>
    <table style="width:100%;margin-top:4px;margin-left:-4x">
        <tr>
            <td style="width:60%"></td>
            <td style="width:40%">
                Florida Property Tax Solutions, LLC
            </td>
        </tr>
    </table>

    <table style="width:100%;margin-top:-2px;margin-left:-4x">
        <tr>
            <td style="text-align: left;width:11%">
                Print Name:</td>
            <td style="text-align: left;border-bottom: 1px solid #000;width: 31%;">{CONTACT_NAME}</td>
            <td style="width:56%"></td>
        </tr>
    </table>`;

    const agreementJoined = `${headerHtml}${client?.content}${footerHtml}`;

    // Auto-fill Fields
    const agreement = agreementJoined.replaceAll('{CONTACT_NAME}', first_name + ' ' + last_name)
        .replaceAll('{EMAIL_ADDRESS}', email_address).replaceAll('{PHONE_NUMBER}', phone_number).replaceAll('{DAY}', currentDay)
        .replaceAll('{MONTH}', currentMonth).replaceAll('{YEAR}', currentYear).replaceAll('{ENTITY_NAME}', entityname).replaceAll('{MAILING_STREET1}', mailingStreet1)
        .replaceAll('{MAILING_STREET2}', mailingStreet2Ammended).replaceAll('{MAILING_CITY}', mailingCity).replaceAll('{MAILING_STATE}', mailingState).replaceAll('{MAILING_COUNTRY}', mailingCountry)
        .replaceAll('{MAILING_POSTALCODE}', mailingPostalcode).replaceAll('{PROPERTY_STREET1}', propertyStreet1).replaceAll('{PROPERTY_STREET2}', propertyStreet2Ammended)
        .replaceAll('{PROPERTY_CITY}', propertyCity).replaceAll('{PROPERTY_STATE}', propertyState).replaceAll('{PROPERTY_COUNTRY}', propertyCountry)
        .replaceAll('{PROPERTY_POSTALCODE}', propertyPostalcode).replaceAll('{FOLIO}', folio).replaceAll('{COUNTY}', county)

    const agreementDisplay = agreement?.replaceAll('{SIGNATURE}', '')

    return (
        <div id="body" className="m-auto">
            <div style={{ maxWidth: '768px', margin: 'auto', position: 'realative' }}>
                {client &&
                    <>
                        <div className='m-auto text-center'>
                            <img style={{ width: '65%' }} className="logo-image mb-1" src={flptslogot} alt="FLPTS Logo" />
                            <h3 className='mb-2 text-center'>Property Tax Review & Appeal Agreement</h3>
                            <ProgressIndicator style={{ padding: '15px', display: 'flex', flexWrap: 'wrap' }} className='m-auto mb-2' spaceEqually={true} currentIndex={progressIndex}>
                                <ProgressStep
                                    style={{ minHeight: '5rem' }}
                                    label="Contact Information"
                                    secondaryLabel="How can we reach you?"
                                />
                                <ProgressStep
                                    style={{ minHeight: '5rem' }}
                                    label="Property Details"
                                    secondaryLabel="Which property's taxes are you appealing?"
                                />
                                <ProgressStep
                                    style={{ minHeight: '5rem' }}
                                    label="Sign Agreement"
                                    secondaryLabel="Sign the FLPTS Agreement"
                                />
                                <ProgressStep
                                    style={{ minHeight: '5rem' }}
                                    label="Confirmation"
                                    secondaryLabel="Appeal Submitted"
                                />
                            </ProgressIndicator>
                        </div>
                        {display === 1 &&
                            <Tile className="w-full d-flex" style={{ minHeight: 0 }}>
                                <div className="col-12 col-sm-12 col-md-12">
                                    <div className='col-12 w-full d-flex mb-1 flex-w'>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                onChange={(e) => setFirst_name(e.target.value)}
                                                value={first_name}
                                                id="fname"
                                                name="fname"
                                                labelText="First Name"
                                                placeholder="Enter first name"
                                                invalidText="First name is required"
                                                invalid={page1Submit === true ? first_name === "" ? true : false : false}
                                                required
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                onChange={(e) => setLast_name(e.target.value)}
                                                value={last_name}
                                                id="lname"
                                                name="lname"
                                                labelText="Last Name"
                                                placeholder="Enter last name"
                                                invalidText="Last name is required"
                                                invalid={page1Submit === true ? last_name === "" ? true : false : false}
                                                required
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                onChange={(e) => setEmail_address(e.target.value)}
                                                value={email_address}
                                                id="email"
                                                name="email"
                                                type="email"
                                                invalidText="Email address is required"
                                                labelText="Email Address"
                                                placeholder="Enter email address"
                                                invalid={page1Submit === true ? email_address === "" ? true : false : false}
                                                required
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                onChange={(e) => setPhone_number(normalizePhone(e.target.value))}
                                                value={phone_number}
                                                id="phone"
                                                name="phone"
                                                labelText="Phone Number"
                                                placeholder="Enter phone number"
                                                invalidText="Phone number is required"
                                                invalid={page1Submit === true ? phone_number === "" ? true : false : false}
                                                required
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                id="entityname"
                                                name="entityname"
                                                onChange={(e) => setEntityname(e.target.value)}
                                                value={entityname}
                                                labelText="Entity Name (optional - if property is owned by a trust, LLC or other entity)"
                                                placeholder="Enter entity name"
                                            />
                                        </div>
                                        <div className='col-12 d-flex mr-auto m-005'>
                                            <h4>Mailing Address</h4>
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                id="street"
                                                name="street"
                                                onChange={(e) => setMailingStreet1(e.target.value)}
                                                value={mailingStreet1}
                                                labelText="Street Address 1"
                                                placeholder="Enter street address 1"
                                                invalidText="Street Address 1 is required"
                                                invalid={page1Submit === true ? mailingStreet1 === "" ? true : false : false}
                                                required
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                id="street2"
                                                name="street2"
                                                onChange={(e) => handleMailStreet2(e.target.value)}
                                                value={mailingStreet2}
                                                labelText="Street Address 2 (optional)"
                                                placeholder="Enter street address 2"
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                id="city"
                                                name="city"
                                                onChange={(e) => setMailingCity(e.target.value)}
                                                value={mailingCity}
                                                labelText="City"
                                                placeholder="Enter city"
                                                invalidText="City is required"
                                                invalid={page1Submit === true ? mailingCity === "" ? true : false : false}
                                                required
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                id="postalcode"
                                                name="postalcode"
                                                onChange={(e) => setMailingPostalcode(e.target.value)}
                                                value={mailingPostalcode}
                                                labelText="ZIP Code"
                                                placeholder="Enter ZIP code"
                                                invalidText="ZIP code is required"
                                                invalid={page1Submit === true ? mailingPostalcode === "" ? true : false : false}
                                                required
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <Select
                                                value={mailingState}
                                                helperText="Please select the state of your property"
                                                id="state"
                                                name="state"
                                                labelText="State"
                                                onChange={(e) => setMailingState(e.target.value)}
                                                invalidText="State is required"
                                                invalid={page1Submit === true ? mailingState === "" || mailingState === "placeholder-item" ? true : false : false}
                                                required
                                            >
                                                <SelectItem
                                                    text="Choose an option"
                                                    value="placeholder-item"
                                                />

                                                <SelectItemGroup
                                                    label="Commonly Used"
                                                >
                                                    {provinces.map((province) => province.common === true & province.country === mailingCountry &&
                                                        <SelectItem
                                                            text={province.province}
                                                            value={province.provincecode}
                                                        />
                                                    )}
                                                </SelectItemGroup>
                                                <SelectItemGroup
                                                    label="Others"
                                                >
                                                    {provinces.map((province) => province.common === false & province.country === mailingCountry &&
                                                        <SelectItem
                                                            text={province.province}
                                                            value={province.provincecode}
                                                        />
                                                    )}
                                                </SelectItemGroup>
                                            </Select>
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <Select
                                                value={mailingCountry}
                                                helperText="Please select the country of your property"
                                                id="country"
                                                name="country"
                                                labelText="Country"
                                                onChange={(e) => setMailingCountry(e.target.value)}
                                                invalidText="Country is required"
                                                invalid={page1Submit === true ? mailingCountry === "" || mailingCountry === "placeholder-item" ? true : false : false}
                                                required
                                            >
                                                <SelectItem
                                                    text="Choose an option"
                                                    value="placeholder-item"
                                                />

                                                <SelectItemGroup
                                                    label="Commonly Used"
                                                >
                                                    {countries.map((country) => country.common === true &&
                                                        <SelectItem
                                                            text={country.country}
                                                            value={country.countrycode}
                                                        />
                                                    )}
                                                </SelectItemGroup>
                                                <SelectItemGroup
                                                    label="Others"
                                                >
                                                    {countries.map((country) => country.common === false &&
                                                        <SelectItem
                                                            text={country.country}
                                                            value={country.countrycode}
                                                        />
                                                    )}
                                                </SelectItemGroup>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='col-12 w-full d-flex mb-1 flex-w m-005'>
                                        <Button disabled={displayOneNull === true ? true : false} onClick={() => submitPage1()}>Continue</Button>
                                    </div>
                                </div>
                            </Tile>
                        }

                        {display === 2 &&
                            <Tile className="w-full d-flex" style={{ minHeight: 0 }}>
                                <div className="col-12 col-sm-12 col-md-12">
                                    <div className='mb-1 d-flex flex-w'>
                                        <Button className='ml-auto' onClick={() => sameAsMailing()}>Same As Mailing Address</Button>
                                    </div>
                                    <div className='col-12 w-full d-flex mb-1 flex-w'>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                id="street"
                                                name="street"
                                                onChange={(e) => setPropertyStreet1(e.target.value)}
                                                value={propertyStreet1}
                                                labelText="Street Address 1"
                                                placeholder="Enter street address 1"
                                                invalidText="Street Address 1 is required"
                                                invalid={page2Submit === true ? propertyStreet1 === "" ? true : false : false}
                                                required
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                id="street2"
                                                name="street2"
                                                onChange={(e) => handlePropStreet2(e.target.value)}
                                                value={propertyStreet2}
                                                labelText="Street Address 2 (optional)"
                                                placeholder="Enter street address 2"
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                id="city"
                                                name="city"
                                                onChange={(e) => setPropertyCity(e.target.value)}
                                                value={propertyCity}
                                                labelText="City"
                                                placeholder="Enter city"
                                                invalidText="City is required"
                                                invalid={page2Submit === true ? propertyCity === "" ? true : false : false}
                                                required
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <TextInput
                                                data-modal-primary-focus
                                                id="postalcode"
                                                name="postalcode"
                                                onChange={(e) => setPropertyPostalcode(e.target.value)}
                                                value={propertyPostalcode}
                                                labelText="ZIP Code"
                                                placeholder="Enter ZIP code"
                                                invalidText="ZIP code is required"
                                                invalid={page2Submit === true ? propertyPostalcode === "" ? true : false : false}
                                                required
                                            />
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <Select
                                                value={propertyState}
                                                helperText="Please select the state of your property"
                                                id="state"
                                                name="state"
                                                invalidText="State is required"
                                                invalid={page2Submit === true ? propertyState === "placeholder-item" || propertyState === "" ? true : false : false}
                                                labelText="State"
                                                onChange={(e) => setPropertyState(e.target.value)}
                                            >
                                                <SelectItem
                                                    text="Choose an option"
                                                    value="placeholder-item"
                                                />

                                                <SelectItemGroup
                                                    label="Commonly Used"
                                                >
                                                    {provinces.map((province) => province.common === true & province.country === propertyCountry &&
                                                        <SelectItem
                                                            text={province.province}
                                                            value={province.provincecode}
                                                        />
                                                    )}
                                                </SelectItemGroup>
                                                <SelectItemGroup
                                                    label="Others"
                                                >
                                                    {provinces.map((province) => province.common === false & province.country === propertyCountry &&
                                                        <SelectItem
                                                            text={province.province}
                                                            value={province.provincecode}
                                                        />
                                                    )}
                                                </SelectItemGroup>
                                            </Select>
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005 mb-1'>
                                            <Select
                                                value={propertyCountry}
                                                helperText="Please select the country of your property"
                                                id="country"
                                                name="country"
                                                labelText="Country"
                                                onChange={(e) => setPropertyCountry(e.target.value)}
                                                invalidText="Country is required"
                                                invalid={page1Submit === true ? propertyCountry === "" || propertyCountry === "placeholder-item" ? true : false : false}
                                                required
                                            >
                                                <SelectItem
                                                    text="Choose an option"
                                                    value="placeholder-item"
                                                />

                                                <SelectItemGroup
                                                    label="Commonly Used"
                                                >
                                                    {countries.map((country) => country.common === true &&
                                                        <SelectItem
                                                            text={country.country}
                                                            value={country.countrycode}
                                                        />
                                                    )}
                                                </SelectItemGroup>
                                                <SelectItemGroup
                                                    label="Others"
                                                >
                                                    {countries.map((country) => country.common === false &&
                                                        <SelectItem
                                                            text={country.country}
                                                            value={country.countrycode}
                                                        />
                                                    )}
                                                </SelectItemGroup>
                                            </Select>
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005'>
                                            <Select
                                                value={county}
                                                helperText="Please select the county of your property"
                                                id="county"
                                                invalidText="County is required"
                                                invalid={page2Submit === true ? county === "placeholder-item" || county === "" ? true : false : false}
                                                labelText="County"
                                                onChange={(e) => setCounty(e.target.value)}
                                            >
                                                <SelectItem
                                                    text="Choose an option"
                                                    value="placeholder-item"
                                                />

                                                <SelectItemGroup
                                                    label="Commonly Used"
                                                >
                                                    {counties.map((county) => county.common === true &&
                                                        <SelectItem
                                                            text={county.county}
                                                            value={county.county}
                                                        />
                                                    )}
                                                </SelectItemGroup>
                                                <SelectItemGroup
                                                    label="Others"
                                                >
                                                    {counties.map((county) => county.common === false &&
                                                        <SelectItem
                                                            text={county.county}
                                                            value={county.county}
                                                        />
                                                    )}
                                                </SelectItemGroup>
                                            </Select>
                                        </div>
                                        <div className='col-6 d-flex mr-auto m-005'>
                                            <TextInput
                                                data-modal-primary-focus
                                                id="folio"
                                                name="folio"
                                                onChange={(e) => setFolio(e.target.value)}
                                                value={folio}
                                                labelText="Folio (optional)"
                                                placeholder="Enter folio"
                                                helperText="This will help us verify the property under appeal"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 w-full d-flex mb-1 flex-w m-005'>
                                        <div className='col-6 d-flex mr-auto'>
                                            <Button className='mr-1' kind="secondary" onClick={() => setDisplay(1) & setProgressIndex(0)}>Go Back</Button>
                                            <Button onClick={() => submitPage2()}>Continue</Button>
                                        </div>
                                    </div>
                                </div>
                            </Tile>
                        }

                        {display === 3 &&
                            <>
                                <Tile className="w-full" style={{ minHeight: 0 }}>
                                    {parse(agreementDisplay)}
                                </Tile>

                                <Tile className="w-full d-flex mt-2" style={{ minHeight: 0 }}>
                                    <div className="col-12 col-sm-12 col-md-12">
                                        <div className='col-12 w-full d-flex mb-1'>
                                            <div className='col-12 d-flex mr-auto'>
                                                <h2 className='mr-05'>Sign Here</h2>
                                                <Button className='ml-auto' onClick={() => signatureCanvas.current.clear() & setIsSigned(false)}>Clear</Button>
                                            </div>
                                        </div>
                                        <div className=''>
                                            <SignatureCanvas ref={signatureCanvas} penColor='black'
                                                onEnd={() => { setIsSigned(true) }}
                                                canvasProps={{ maxWidth: 2.5, height: 350, className: 'sigCanvas bg-white w-full' }} />
                                        </div>
                                        <div className='col-12 w-full d-flex mb-1 mt-2'>
                                            <Button kind="secondary" className='m-auto' onClick={() => setDisplay(2) & setProgressIndex(1)}>Go Back</Button>

                                            {isSubmitting || success ? (
                                                <InlineLoading
                                                    className='m-auto'
                                                    style={{ width: 'auto' }}
                                                    description={description}
                                                    status={success ? inlineLoadingState : 'active'}
                                                    aria-live={ariaLive}
                                                />
                                            ) : (
                                                <Button disabled={!isSigned} className='m-auto' onClick={(e) => submitAgreement(e)}>Submit</Button>
                                            )}
                                        </div>
                                    </div>
                                </Tile>
                            </>
                        }
                        {display === 4 &&
                            <>
                                <Tile className="w-full" style={{ minHeight: 0 }}>
                                    <p style={{ fontSize: '24px', textAlign: 'center', color: 'green', margin: 'auto' }}>
                                        Appeal Agreement has been submitted!
                                    </p>
                                    <p style={{ margin: 'auto' }}>
                                        A copy of the signed agreement has been sent to your email. We will reach out to you shortly.
                                    </p>
                                    <p style={{ margin: 'auto' }}>
                                        After you have downloaded the document you may close this window.
                                    </p>
                                </Tile>
                                <Tile className="w-full" style={{ minHeight: 0, display: 'flex' }}>
                                    <Button style={{ margin: 'auto' }} onClick={() => downloadPDF()}>
                                        Download Signed Agreement
                                    </Button>
                                </Tile>
                            </>
                        }
                    </>
                }
            </div>
        </div>
    )
}

export default SignatureShell